/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Week_Session_Stats_In_ProgressInputs */

const fr_week_session_stats_in_progress = /** @type {(inputs: Week_Session_Stats_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En cours`)
};

/**

* @param {Week_Session_Stats_In_ProgressInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const week_session_stats_in_progress = /** @type {((inputs?: Week_Session_Stats_In_ProgressInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Week_Session_Stats_In_ProgressInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_week_session_stats_in_progress(inputs)
});